import { useAuth } from '../contexts/AuthContext';

// PM Demo Feature Flag - Only for specific users
export const useFeatureFlag = (flagName) => {
  const { user } = useAuth();

  // Define which features are available to which users
  const featureAccess = {
    'pm_demo': [
      'eric@exineducation.com', // Developer access
      'eric@aiappbuilder.io',   // Developer access
      // Blades AV team members only
      'brandon@bladesav.com',   // Brandon Bennett
      'mark@bladesav.com',      // Mark Hough
    ]
  };

  // Check if feature exists and user has access
  if (!featureAccess[flagName]) {
    return false;
  }

  // Check if user email matches allowed list
  const allowedEmails = featureAccess[flagName];
  const userEmail = user?.email?.toLowerCase() || '';

  // Check exact email match or domain match
  const hasAccess = allowedEmails.some(allowed => {
    if (allowed.includes('@')) {
      // Exact email match
      return userEmail === allowed.toLowerCase();
    } else {
      // Domain match
      return userEmail.endsWith(allowed.toLowerCase());
    }
  });

  // Also check localStorage override for demo purposes (dev only)
  const isDev = import.meta.env.MODE === 'development';
  const localOverride = isDev && localStorage.getItem(`feature_${flagName}`) === 'true';

  return hasAccess || localOverride;
};

// Specific PM feature flag
export const usePMFeatures = () => {
  return useFeatureFlag('pm_demo');
};